import Loader from "components/shared/loader";
import React from "react";
import { DefaultTemplate } from "./templates";

export default class ConfirmModal extends DefaultTemplate {
    action = () => {
        if (!this.state.isLoading) {
            this.setState({ isLoading: true });
            const result = this.props.action();
            return (result && result.then ? result : Promise.resolve(result)).then((res) =>
                res || {} ? this.close(true, res) : this.setState({ isLoading: false }),
            );
        }
    };

    close = (success = false, res) => {
        const { close, onCloseAction, onSuccessAction } = this.props;
        if (onCloseAction) {
            onCloseAction();
        }
        if (success && onSuccessAction) {
            close();
            return onSuccessAction(res);
        } else {
            return close();
        }
    };

    renderBody = () => {
        const body = this.state.isLoading ? <Loader prefix="margin-center" /> : this.props.text;
        return <div className="modal-window__body">{body}</div>;
    };

    cancelBtnClickHandler = () => {
        const result = this.props.onCancelAction();
        return (result && result.then ? result : Promise.resolve(true)).then((res) =>
            res || {} ? this.close(false) : this.setState({ isLoading: false }),
        );
    };

    renderFooter = () => {
        const { buttons, onCancelAction } = this.props;
        const { confirm, cancel } = buttons || {};
        return (
            <div className="modal-window__footer">
                <div
                    className="btn btn-secondary btn-sm modal-window__footer-action"
                    onClick={() => (onCancelAction ? this.cancelBtnClickHandler() : this.close(false))}
                >
                    {cancel || "Отменить"}
                </div>
                <div className="btn btn-brand btn-sm modal-window__footer-action" onClick={this.action}>
                    {confirm || "Принять"}
                </div>
            </div>
        );
    };
}
